(function() {
    'use strict';
    angular.module('wbDashboard').directive('allocationChartAurea', ['$window', '$timeout', function($window, $timeout) {
    return {
        restrict: 'A',
        scope: {
            data: '=',
            tableData: '=?',
            options: '=?',
            label: '@',
            onClick: '&',
            dynamic: '@?'
        },
        templateUrl: "app/themes/aurea/directives/allocation-chart/allocation-chart.tpl.html",
        link: {
            pre: function(scope, ele, attrs) {
                scope.stickyOptions = angular.extend({}, {
                    anchor:"top",
                    container: "portfolio-allocation-chart",
                    offsetTop: 0,
                    offsetBottom: 0,
                    enable: true
                }, scope.options.sticky || {});

            },
            post: function(scope, ele, attrs) {
                //make sure this matches the $allocation-chart-narrow-width in _allocation-chart.scss
                //sass: breakpoint-max(sm)
                scope.mobileWidth = (768 - 0.02) + "px";

                //for waypoints scroll classes
                scope.directScroller = {
                    waypoint: {},
                    angles: [],
                    selectedAngle: null,
                    invertGraph: true
                };

                scope.rowData = { count: {}, show: {} };

                //will be filled in with child pie directive
                scope.highlight = {
                    on : function() {},
                    off : function() {}
                };


                var totalCount = 0;
                var rowCount = {};
                scope.totalCount = function(key) {
                    if (isNaN(rowCount[key])) {
                        rowCount[key] = totalCount;
                        totalCount++;
                    }
                    return rowCount[key];
                };

                scope.getKey = function (data) {
                    var key = "";
                    if (data.code) {
                        key += data.code;
                    }
                    key += "-";
                    if (data.ticker) {
                        key += data.ticker;
                    }
                    return key;
                };

                scope.$watch("data", function (data) {
                    if (data) {
                        scope.rowData = { count: {}, show: {} };
                        //after dom is finished updating, the waypoint triggerpoints are incorrect until refreshed
                        $timeout(function() {
                            //if waypoint thinks something hasn't changed, refresh won't touch it even if it has changed
                            //clearing the array fixes this
                            scope.directScroller.waypoint = {};
                            refreshDisplay();
                        },100);
                    }
                });

                //update waypoints when subrows opened/closed
                scope.$watch("rowData.show", function() {
                    $timeout(function() {
                        refreshDisplay();
                    }, 100);
                }, true);

                function refreshDisplay() {
                    $window.Waypoint.refreshAll();
                }
            },
        }
    };
    }]);
})();
